<script>
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerIconRetina from 'leaflet/dist/images/marker-icon-2x.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';
import PartnerApi from "@/services/partner-api";
import 'leaflet.markercluster';
export default {
  name: 'addPartnersByZone',
  components: {},

  props : {
    sector:{
          type:Array,
          default: () => [],
      },

  
    },

  data() {
    return {

      options: [],
      selectedOptions: [],
      filteredMarkers:[],

      defaultIcon: L.icon({
        iconUrl: markerIcon,
        iconRetinaUrl: markerIconRetina,
        shadowUrl: markerShadow,
        iconSize: [25, 35], 
        iconAnchor: [12, 41], 
        popupAnchor: [1, -34], 
        shadowSize: [10, 10],
      }),

      clusteringMarkerIcon: L.icon({
        iconUrl: require("@/assets/icons/marker.png"),
        shadowUrl: markerShadow,
        iconSize: [20, 31], 
        iconAnchor: [12, 41], 
        popupAnchor: [1, -34], 
        shadowSize: [10, 10],  
      }),

      filteredPharmaIcon: L.icon({
        iconUrl: require("@/assets/icons/pharmaMarker.png"),
        shadowUrl: markerShadow,
        iconSize: [20, 31], 
        iconAnchor: [12, 41], 
        popupAnchor: [1, -34], 
        shadowSize: [10, 10],  
      }),

      markers: [],
      allMarkers: [],

      bounds: null ,
      zoomLevel: null,

      radius:0,
      latitude:null,
      longitude:null
    };
  },

  mounted() {
    this.initializeMap()
  },


  watch: {
    radius(newRadius) {
      if (this.currentCircle) {
        this.updateCircleRadius(newRadius);
        this.filterMarkers()

      }
    },
    latitude() {
      if (this.latitude && this.longitude) {
        this.addCircle([this.latitude, this.longitude]);
        this.filterMarkers()

      }
    },
    longitude() {
      if (this.longitude && this.latitude) {
        this.addCircle([this.latitude, this.longitude]);
        this.filterMarkers()
      }
    },

    },


  methods: {

    addCampaignPartner(){
      this.$emit('filterdPartnerName', this.filteredMarkers.map(item => item.properties.id));
    },

    updateCircleRadius(newRadius) {
      if (this.currentCircle) {
        this.currentCircle.setRadius(newRadius);
      }
    },

    findAllPartner(){

      PartnerApi.findAllPartner(this.bounds.getSouth(),this.bounds.getNorth(),this.bounds.getWest(),this.bounds.getEast(),this.zoomLevel).then(result => {
        if(result){
          this.allMarkers = result

          this.loadMarkers()

        }
      })
    },
    initializeMap() {
      const isMobile = window.innerWidth <= 768;
      const latLng = isMobile ? [34.7589023, 9.3267611] : [34.7236, 3.2794];

      this.map = L.map('add_partner_map').setView(latLng, 6);

    const osmLayer = L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        minZoom:6,
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    });

    this.map.on('click', this.handleMapClick);
    

    osmLayer.addTo(this.map);

    const baseLayers = {
        "Standard": osmLayer,
    };

    L.control.layers(baseLayers).addTo(this.map);

    this.loadPartners();
    this.map.on('moveend', () => {
        this.loadPartners();
    });
    },

    handleMapClick(event) {
        const { lat, lng } = event.latlng;
        this.latitude = lat;
        this.longitude = lng;

      },

    addCircle(position) {
      if (this.currentCircle) {
          this.map.removeLayer(this.currentCircle);
      }

      this.currentCircle = L.circle(position, {
          color: 'blue',
          fillColor: 'blue',
          fillOpacity: 0.2,
          radius: this.radius ? this.radius : 0
      }).addTo(this.map);
    },

    addMarker(position) {
        if (this.currentMarker) {
          this.map.removeLayer(this.currentMarker);
        }

        this.currentMarker = L.marker(position, { icon: this.defaultIcon })
          .addTo(this.map)
          .bindPopup(`${position[0].toFixed(5)}, ${position[1].toFixed(5)}`)
          .openPopup();
      },

    loadPartners() {
        this.bounds = this.map.getBounds();
        this.zoomLevel = this.map.getZoom();

        this.findAllPartner();
    },

    loadMarkers() {
      this.map.eachLayer(layer => {
          if (layer instanceof L.Marker) {
              this.map.removeLayer(layer);
          }
      });

      if(this.allMarkers.features == null){
        return
      }

      this.filteredMarkers = (this.allMarkers?.features || []).filter(marker => {
          const { coordinates } = marker.geometry; 
          const distance = this.calculateDistance([this.latitude, this.longitude], [coordinates[1], coordinates[0]]);
          const matchesRadius =(this.radius > 0 ? distance <= this.radius : true)
          return  matchesRadius;
      });

      L.NumberedDivIcon = L.Icon.extend({
      options: {
          iconUrl: '',
          number: '',
          shadowUrl: null,
          iconAnchor: new L.Point(9.57, 57),
          popupAnchor: new L.Point(0, 28),
          className: 'leaflet-div-icon',
          showCoverageOnHover: true,

      },

      createIcon: function () {
          var div = document.createElement('div');
          var img = this._createImg(this.options.iconUrl);
          var numdiv = document.createElement('div');
          numdiv.setAttribute("class", "number");

          const displayNumber = this.options.number > 99 ? "+99" : this.options.number;
          numdiv.innerHTML = displayNumber || '';

          if (displayNumber === "+99") {
              numdiv.style.fontSize = "10px";
              numdiv.style.padding = "0px 0px";
          } else {
              numdiv.style.fontSize = "11px";
          }

          div.appendChild(img);
          div.appendChild(numdiv);
          this._setIconStyles(div, 'icon');
          return div;
      }
  });


  this.filteredMarkers.forEach(marker => {
      const { coordinates } = marker.geometry;
      const { name, sector } = marker.properties;

      // For non-Pharmacie markers, use default icon
      if (sector !== "Pharmacie") {
          L.marker([coordinates[1], coordinates[0]], { icon: this.defaultIcon })
              .bindPopup(name)
              .addTo(this.map);
      } 


      if (marker.clusterCount > 1){
        
        const markerIcon = new L.NumberedDivIcon({
              number: marker.clusterCount > 1 ? marker.clusterCount : ''
          });
              L.marker([coordinates[1], coordinates[0]], { icon: markerIcon })
              .addTo(this.map);
      }



  });

      // Add other markers to the map without clustering
      const otherMarkers = (this.allMarkers?.features || []).filter(marker => !this.filteredMarkers.includes(marker));
      otherMarkers.forEach(marker => {
          const { coordinates } = marker.geometry;
          const { name } = marker.properties;

          L.marker([coordinates[1], coordinates[0]], { icon: this.clusteringMarkerIcon })
              .bindPopup(name)
              .addTo(this.map);
      });

      // Add pharma markers to the map without clustering
      const pharmaMarkers = (this.allMarkers?.features || []).filter(marker => 
          marker.properties.sector === "Pharmacie" && this.filteredMarkers.includes(marker));
      pharmaMarkers.forEach(marker => {
          const { coordinates } = marker.geometry;
          const { name } = marker.properties;

          L.marker([coordinates[1], coordinates[0]], { icon: this.filteredPharmaIcon })
              .bindPopup(name)
              .addTo(this.map);
      });

    },

    filterMarkers() {
      this.loadMarkers();
      
    },

    calculateDistance(center, position) {
      const [lat1, lon1] = center;
      const [lat2, lon2] = position;
      
      const R = 6371e3;
      const φ1 = lat1 * Math.PI / 180;
      const φ2 = lat2 * Math.PI / 180;
      const Δφ = (lat2 - lat1) * Math.PI / 180;
      const Δλ = (lon2 - lon1) * Math.PI / 180;

      const a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
                Math.cos(φ1) * Math.cos(φ2) *
                Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

      return R * c; 
    }

  },
};
</script>




<template>

  <div>    
    <div class="row mt-5">
      <div class="col-12 col-md-3">
        
        <div class="row mr-4 ml-4">

              <div  class="col-12 d-flex justify-content-between">
              
              <div>
                <div class="text-secondary font-size-14 pb-2"> {{$t('membershipApplication.label.latitude')}} </div>
                  <b-form-group   class="font-weight-bold font-size-14 pr-3 "   >
                    <b-form-input class="bg-light mr-2" :placeholder="$t('membershipApplication.input.latitude')"   
                    v-model="latitude"
                     ></b-form-input>      
                  </b-form-group>
              </div>

              <div>
                <div class="text-secondary font-size-14 pb-2"> {{$t('membershipApplication.label.longitude')}} </div>
                <b-form-group   class="font-weight-bold font-size-14 pr-3 "   >
                  <b-form-input class="bg-light" :placeholder="$t('membershipApplication.input.longitude')"   
                  v-model="longitude"
                   ></b-form-input>   
                </b-form-group>
              </div>
                  
              </div>

              <div>

                <div class="row">
                  <div class="col-6">
                    <div class="text-secondary font-size-14 pt-2 pb-2"> {{$t('campaign.label.radius')}} </div>
                    <b-form-group   class="font-weight-bold font-size-14 pr-3 "   >
                        <b-input-group   >
                            <b-form-input class="text-right " :placeholder="$t('campaign.input.radius')"  type="number" 
                            v-model="radius" ></b-form-input>                              
                        </b-input-group>
                    </b-form-group>
                  </div>

                  <div class="col-6">
                    <div class="text-white font-size-14 pt-2 pb-2">_ </div>

                    <b-button variant="primary" @click="addCampaignPartner()" class="float-right w-100 pt-2 pb-2">
                      <span class="font-weight-bold text-uppercase">
                          Ajouter 
                      </span>
                      </b-button>
                  </div>
                </div>

                
              </div>

              <div class=" w-100 mt-4" >
                <div >{{ this.filteredMarkers  ? this.filteredMarkers.length +' Partenaire(s)' : ''}}</div>
                <div v-if="this.filteredMarkers.length" class="scroll-container mt-2 pr- pl-2 " style="border: 1px solid #ddd; border-radius: 5px;">
                  <div v-for="(item, index) in filteredMarkers" :key="index" class=" mt-2">
                    <div class=" p-2">
                      <div class="row align-items-center">
                        <div class="col-8">
                          <div class="font-weight-bold">{{ item.properties.name }}</div>
                          <div class="text-muted small">{{ item.properties.sector }}</div>
                        </div>
                        <div class="col-4 text-end">
                          <span>{{ item.properties.countryName }} - {{ item.properties.cityName }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>


          </div>



      </div>

      <div class="col-12 col-md-9 mt-4 mt-md-0">
        <div  class="map-container" >
          <div id="add_partner_map" style="cursor: crosshair" ></div>
          
        </div>
        
      </div>

    </div>
  </div>

</template>




<style scoped>
  #add_partner_map {
    width: 100%;
    height: 500px;
    border: 1px solid rgb(221, 221, 221);
    border-radius: 3px;
  }

.map-container {
  border: 1px solid rgb(221, 221, 221);
  border-radius: 3px;
  overflow: hidden;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.scroll-container {
  max-height: 250px;
  overflow-y: auto;
  padding-right: 5px;
}

.scroll-container::-webkit-scrollbar {
  width: 6px;
}

.scroll-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.scroll-container::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

.scroll-container::-webkit-scrollbar-thumb:hover {
  background: #555;
}

</style>

<style >

.leaflet-div-icon {
	background: transparent;
	border: none;
}



.leaflet-marker-icon .number {
    position: relative;
    width: 20px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    background-color: #fff; 
    border-radius: 50%; 
    font-weight: normal;
}


</style>

